import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { ArrowRight, ShoppingBag, Percent } from 'lucide-react';
import { Button } from '../ui/button';
import { useSiteSettings } from '../../hooks/useSiteSettings';

export const PromotionalBanner = () => {
  const { t } = useTranslation();
  const { getSetting } = useSiteSettings();

  return (
    <section className="py-12 bg-gradient-to-r from-primary/10 via-accent/20 to-primary/10">
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-8 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <div className="inline-flex items-center gap-2 bg-primary/10 px-4 py-2 rounded-full mb-4">
              <Percent className="w-4 h-4 text-primary" />
              <span className="text-sm font-semibold text-primary">
                {getSetting('promo_badge_text', 'Limited Time Offer')}
              </span>
            </div>
            <h2 className="font-serif text-4xl sm:text-5xl font-bold text-foreground mb-4">
              {getSetting('promo_title', 'Up to 25% Off')}
              <br />
              <span className="text-primary">{getSetting('promo_subtitle', 'Premium Products')}</span>
            </h2>
            <p className="text-lg text-muted-foreground mb-6">
              {getSetting('promo_description', 'Discover our exclusive selection of natural cosmetics and wellness products at unbeatable prices.')}
            </p>
            <Link to="/shop">
              <Button size="lg">
                <ShoppingBag className="w-5 h-5 mr-2" />
                {getSetting('promo_button_text', 'Shop Deals Now')}
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
            </Link>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-elegant">
              <img
                src={getSetting('promo_image', 'https://images.unsplash.com/photo-1556228720-195a672e8a03?w=800&q=85')}
                alt="Premium products"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-4 -right-4 bg-destructive text-destructive-foreground p-6 rounded-2xl shadow-xl">
              <p className="text-sm font-semibold mb-1">
                {getSetting('promo_discount_text', 'Save up to')}
              </p>
              <p className="text-4xl font-bold">{getSetting('promo_discount_percentage', '25%')}</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};